import { useState, useEffect } from 'react';
// store
import { useSelector, useDispatch, SET_GROUP, DELETE_GROUP, SET_DEVICES, DELETE_DEVICES, SET_DEVICE, DELETE_DEVICE,  } from '../../store';
// hooks
import useResponsive from '../../hooks/useResponsive';
// @devextreme
import { Popover } from 'devextreme-react/popover';
// assets
import { ReactComponent as Search } from '../../assets/form/search.svg';
import { ReactComponent as CloseIcon } from '../../assets/button/close.svg';
// styles
import { GroupsButton, MobilePopover, Close } from './styles';
import { SearchPopover, SearchInput } from '../../styles';
// apis
import { getGroupsInfo, getDevicesInfo } from '../../apis';

// ----------------------------------------------------------------------

export default function GroupsField({ visible, setVisible, active, setActive, visibleAccount, setVisibleAccount }: any) {
  const dispatch = useDispatch();
  const group = useSelector((state) => state.group);

  const mobile = useResponsive('down', 'md');

  const [ defaultGroups, setDefaultGroups ] = useState({ content: [], number: 0, last: true, empty: true });
  const [ groups, setGroups ] = useState({ content: [], number: 0, last: true, empty: true });
  const [ keyword, setKeyword ] = useState('');

  useEffect(() => {
    if ( visible ) {
      setGroups(defaultGroups);
      setKeyword('');
    }
  }, [visible]);

  useEffect(() => {
    ( async () =>
      await getGroupsInfo(keyword, groups.number)
        .then( async (response) => {
          setGroups(response);
          setDefaultGroups(response);
          if ( !group.id && response.content.length > 0 ) {
            dispatch( SET_GROUP({
              id: response.content[0].iotGroupId,
              name: response.content[0].iotGroupName,
              waterTemperature: response.content[0].waterTemperature,
              waterTemperatureUnit: response.content[0].waterTemperatureUnit
            }));
          } else if ( response.content.length === 0) {
            dispatch( DELETE_GROUP() );
            dispatch( DELETE_DEVICES() );
            dispatch( DELETE_DEVICE() );
          }
        })
        .catch(() => {
          setGroups({ content: [], number: 0, last: true, empty: true });
          setDefaultGroups({ content: [], number: 0, last: true, empty: true });
          dispatch( DELETE_GROUP() );
          dispatch( DELETE_DEVICES() );
          dispatch( DELETE_DEVICE() );
        })
    )();
  }, []);

  useEffect(() => {
    if ( group.id ) {
      ( async () =>
        await getDevicesInfo(group.id)
          .then((response) => {
            if ( response.length > 0 ) {
              dispatch( SET_DEVICES(response) );
              dispatch( SET_DEVICE(response[0]) );
            } else {
              dispatch( DELETE_DEVICES() );
              dispatch( DELETE_DEVICE() );
            }
          })
          .catch(() => {
            dispatch( DELETE_DEVICES() );
            dispatch( DELETE_DEVICE() );
          })
      )();
    }
  }, [group]);

  const handleSearch = async (more?: boolean) => {
    if ( keyword.length > 0 && keyword.replace(/ /g, '').length === 0 ) return;

    await getGroupsInfo(keyword, more? groups.number + 1 : 0)
      .then((response) => {
        if ( !response.first ) {
          const array = [ ...groups.content, ...response.content ];
          response.content = array;
        }
        setGroups(response);
      })
      .catch(() => {
        setGroups({ content: [], number: 0, last: true, empty: true });
      });
  };

  const handleSelection = async (value: any) => {
    setVisible(false);
    dispatch( SET_GROUP({ id: value.iotGroupId, name: value.iotGroupName, waterTemperature: value.waterTemperature, waterTemperatureUnit: value.waterTemperatureUnit }));
  };

  return (
    <>
      <GroupsButton type='button' id='groups' onClick={() => {
        if ( mobile && !visible ) {
          if ( !active ) setActive(true);
          if ( visibleAccount ) setVisibleAccount(false);
        }
        setVisible(!visible);
      }} $active={visible}>
        <p>{ group?.name }</p>
        <div />
      </GroupsButton>

      { mobile &&
        <MobilePopover $visible={visible}>
          <Close>
            <button type='button' onClick={() => setVisible(false)}><CloseIcon /></button>
          </Close>
          
          <SearchPopover>
            <SearchInput $disabled={defaultGroups.empty}>
              <input
                type='text'
                value={keyword}
                onChange={(event) => setKeyword(event.target.value)}
                onKeyDown={(event) => { if (event.key === 'Enter') handleSearch() }}
                disabled={defaultGroups.empty}
              />
              <Search />
            </SearchInput>
              
            { groups.content.map((item) => (
              <button type='button' key={item.iotGroupName} onClick={() => handleSelection(item)}>
                { item.iotGroupName }
              </button>
            ))}
            { !groups.last &&
              <button type='button' onClick={() => handleSearch(true)} className='last'>더보기<div /></button>
            }
          </SearchPopover>
        </MobilePopover>
      }

      { !mobile &&
        <Popover
          target='#groups'
          visible={visible}
          hideOnOutsideClick={true}
          onHiding={() => setVisible(false)}
        >
          <SearchPopover>
            <SearchInput $disabled={defaultGroups.empty}>
              <input
                type='text'
                value={keyword}
                onChange={(event) => setKeyword(event.target.value)}
                onKeyDown={(event) => { if (event.key === 'Enter') handleSearch() }}
                disabled={defaultGroups.empty ? true : false}
              />
              <Search />
            </SearchInput>
            
            { groups.content.map((item) => (
              <button type='button' key={item.iotGroupName} onClick={() => handleSelection(item)}>
                { item.iotGroupName }
              </button>
            ))}
            { !groups.last &&
              <button type='button' onClick={() => handleSearch(true)} className='last'>더보기<div /></button>
            }
          </SearchPopover>
        </Popover>
      }
    </>
  );
}